import { render, staticRenderFns } from "./FillImageColor.vue?vue&type=template&id=22944312&scoped=true"
import script from "./FillImageColor.vue?vue&type=script&lang=js"
export * from "./FillImageColor.vue?vue&type=script&lang=js"
import style0 from "./FillImageColor.vue?vue&type=style&index=0&id=22944312&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22944312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22944312')) {
      api.createRecord('22944312', component.options)
    } else {
      api.reload('22944312', component.options)
    }
    module.hot.accept("./FillImageColor.vue?vue&type=template&id=22944312&scoped=true", function () {
      api.rerender('22944312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/FillImageColor.vue"
export default component.exports